
import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { Segment, Header, Button, Message } from 'semantic-ui-react';
import { additives } from '@/services/api';
import { Additive } from '@/types/additive';
import { AdditiveForm } from './AdditiveForm';

export function AdditiveDetail() {
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();
  const [additive, setAdditive] = useState<Additive | null>(null);
  const [error, setError] = useState<string | null>(null);
  const [isEditing, setIsEditing] = useState(false);

  useEffect(() => {
    loadAdditive();
  }, [id]);

  const loadAdditive = async () => {
    try {
      const response = await additives.get(Number(id));
      setAdditive(response.data);
      setError(null);
    } catch (error) {
      setError('Failed to load additive');
    }
  };

  const handleDelete = async () => {
    if (!additive) return;
    
    try {
      await additives.delete(additive.id);
      navigate('/additives');
    } catch (error) {
      setError('Failed to delete additive');
    }
  };

  if (error) {
    return (
      <Message negative>
        <Message.Header>Error</Message.Header>
        <p>{error}</p>
      </Message>
    );
  }

  if (!additive) {
    return <div>Loading...</div>;
  }

  if (isEditing) {
    return (
      <AdditiveForm
        additive={additive}
        onClose={() => setIsEditing(false)}
        onSave={async () => {
          await loadAdditive();
          setIsEditing(false);
        }}
      />
    );
  }

  return (
    <Segment>
      <Header as="h2">{additive.name}</Header>
      
      <div style={{ marginBottom: '1rem' }}>
        <strong>Notes:</strong>
        <p>{additive.notes || 'No notes available'}</p>
      </div>

      <div style={{ marginBottom: '1rem' }}>
        <strong>Usage Count:</strong>
        <p>{additive.stats?.recipes?.count || 0} recipes</p>
      </div>

      <div style={{ display: 'flex', gap: '1rem' }}>
        <Button primary onClick={() => setIsEditing(true)}>
          Edit
        </Button>
        <Button
          negative
          onClick={handleDelete}
          disabled={additive.stats?.recipes?.count > 0}
        >
          Delete
        </Button>
        <Button onClick={() => navigate('/additives')}>
          Back to List
        </Button>
      </div>
    </Segment>
  );
} 